import styled, { css, keyframes } from 'styled-components';
import * as C from '../../shared-styles/Colors'
import FontGraphie from '../../shared-styles/graphieFont';

export const ParentSignupForm = styled.form``;

export const InputWrap = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;
export const Label = styled.div`
  ${FontGraphie(1.6,1.2,4)}
  text-align: left;
  margin-bottom: -2rem;
  margin-left: 1.4rem;
  padding: 0 1rem;
  width: fit-content;
  color: ${C.indigo};
  background: ${C.white};
  display: none;
  ${props => props.showLabel?css`
    display: block;
    position: relative;
  `:css``}
`;
export const InputGroup = styled.div``
export const TextInput = styled.input`
  ${FontGraphie(1.6,1.2,4)};
  margin-top: 1rem;
  box-shadow: none;
  padding-left: 2rem;
  height: 5.6rem;
  width: 100%;
  ${props => props.showLabel?css`
    border: 0.1rem solid ${C.indigo};
  `:css`
    border: 0.1rem solid ${C.lightBlueGrey};
  `}
  box-sizing: border-box;
  border-radius: 3rem;
  color: ${C.pureBlack};

  &::placeholder {
    color: ${C.midGray};
  }
`;

export const ShowPasswordEye = styled.img`
  position: absolute;
  top: 3.3rem;
  right: 2.8rem;
  cursor: pointer;
  width: 1.8rem;
`;

export const HelperText = styled.div`
  padding: 0.3rem 0.5rem;
  text-align: left;
  font-size: 1.2rem;
  color: ${C.lightBlack};
`;

export const ErrorMessage = styled.div`
  padding: 0.3rem 0.5rem;
  text-align: left;
  font-size: 1.2rem;
  color: ${C.errorRed};
`;

export const FormSubmit = styled.input`
  ${FontGraphie(1.8,1.2,4)};
  height: 5.6rem;
  width: 100%;
  box-sizing: border-box;
  border-radius: 3rem;
  background: ${C.indigo};
  color: ${C.white};
  border: 0.1rem solid ${C.indigo};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const progressSpinnerRotate = keyframes`
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  100% {
    transform: translateY(-50%) rotate(360deg);
  }
`;

export const FormSubmitWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    right: 2.8%;
    top: 50%;
    width: 3.3rem;
    height: 3.3rem;
    border: 0.2rem solid ${C.white};
    border-top: 0.2rem solid transparent;
    border-radius: 50%;
    transform: translateY(-50%);
    display: ${({ showProgressSpinner }) => (showProgressSpinner ? "block" : "none")};

    ${({ showProgressSpinner }) =>
    showProgressSpinner &&
    css`
      animation: ${progressSpinnerRotate} 1s linear infinite;
    `}
  }
`;